<script>
import { Line } from "vue-chartjs";

export default {
    name: "SmoothLineChart",
    extends: Line,
    props: {
        // Recebe o formato customizado do pai: 
        // { datasets: [10, 20...], labels: ['Jan', 'Fev'...], tooltips: ['R$ 10,00'...] }
        chartData: {
            type: Object,
            required: true,
            default: () => ({ datasets: [], labels: [], tooltips: [] }),
        },
        height: {
            type: [String, Number],
            default: 50,
        },
    },
    data() {
        return {
            localOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: false },
                layout: {
                    padding: { top: 10, bottom: 0, left: 0, right: 0 }
                },
                // 1. Adicione a configuração de Hover explícita
                hover: {
                    mode: "nearest",
                    intersect: false,
                    animationDuration: 0,
                },
                scales: {
                    xAxes: [{ display: false }],
                    yAxes: [{ display: false, ticks: { beginAtZero: true } }],
                },
                elements: {
                    line: {
                        tension: 0.4,
                        borderWidth: 2,
                        borderColor: "#17B26A",
                        backgroundColor: "rgba(23, 178, 106, 0.15)",
                        fill: true,
                    },
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 5,
                        backgroundColor: "#17B26A",
                        borderColor: "#FFFFFF",
                        borderWidth: 2,
                    },
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    enabled: false,
                    custom: function (tooltipModel) {
                        let tooltipEl = document.getElementById('chartjs-tooltip');

                        if (!tooltipEl) {
                            tooltipEl = document.createElement('div');
                            tooltipEl.id = 'chartjs-tooltip';
                            tooltipEl.style.position = 'absolute';
                            tooltipEl.style.background = '#FCFCFD';
                            tooltipEl.style.color = '#384250';
                            tooltipEl.style.borderRadius = '4px';
                            tooltipEl.style.padding = '6px';
                            tooltipEl.style.pointerEvents = 'none'; // Importante para não piscar
                            tooltipEl.style.transform = 'translate(-50%, 0)'; // Centraliza horizontalmente
                            tooltipEl.style.transition = 'all .1s ease';
                            tooltipEl.style.fontSize = '12px';
                            tooltipEl.style.fontFamily = 'Helvetica Neue, Helvetica, Arial, sans-serif';
                            tooltipEl.style.zIndex = 100;
                            tooltipEl.style.boxShadow = '0px 4px 12px rgba(0, 0, 0, 0.25)';
                            document.body.appendChild(tooltipEl);
                        }

                        if (tooltipModel.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        if (tooltipModel.body) {
                            const dataIndex = tooltipModel.dataPoints[0].index;
                            let text = "";
                            const vueComponent = this._chart.canvas.parentElement.__vue__ || this._chart.canvas.__vue__;

                            if (vueComponent && vueComponent.chartData && vueComponent.chartData.tooltips) {
                                text = vueComponent.chartData.tooltips[dataIndex];
                            } else {
                                text = tooltipModel.dataPoints[0].yLabel;
                            }

                            tooltipEl.innerHTML = text;
                        }

                        const position = this._chart.canvas.getBoundingClientRect();

                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                        const tooltipHeight = tooltipEl.offsetHeight;
                        let topY = position.top + window.pageYOffset + tooltipModel.caretY - tooltipHeight - 10;

                        if (topY < window.pageYOffset) {
                            topY = position.top + window.pageYOffset + tooltipModel.caretY + 10;
                        }

                        tooltipEl.style.top = topY + 'px';
                    }
                },
            },
        };
    },
    mounted() {
        this.renderLineChart();
    },
    watch: {
        chartData: {
            handler() {
                // Se os dados mudarem, redesenha
                this.renderLineChart();
            },
            deep: true,
        },
    },
    methods: {
        renderLineChart() {
            // Transforma os dados simples do Pai para o formato do Chart.js
            const dataForChart = {
                labels: this.chartData.labels || [],
                datasets: [
                    {
                        // Os dados numéricos
                        data: this.chartData.datasets || [],
                        // As cores já estão definidas em 'options.elements' (global para este chart),
                        // mas podemos forçar aqui se necessário:
                        borderColor: "#17B26A",
                        backgroundColor: "rgba(23, 178, 106, 0.15)",
                    },
                ],
            };

            this.renderChart(dataForChart, this.localOptions);
        },
    },
};
</script>